
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmTooltip 
} from '@vime/core';

import { define } from '../lib';
  

const TooltipInputs: string[] = [
  'hidden',
  'active',
  'position',
  'direction',
  'isTouch',
  'isMobile',
];

const TooltipMethods: string[] = [
  
];

const TooltipOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface Tooltip extends Components.VmTooltip {}

@ProxyCmp({
  inputs: TooltipInputs,
  methods: TooltipMethods,
})
@Component({
  selector: 'vm-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: TooltipInputs,
  outputs: TooltipOutputs,
})
export class Tooltip {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-tooltip', VmTooltip);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  